const callable = (func, ...params) => {
  if (typeof func === 'function') {
    return func(...params)
  }
}

export default callable
